import disclaimerConfig from './disclaimer.json';

export function linkStocks(myContent, stocks) {
  let content = myContent;
  if (!stocks || !stocks[0]) {
    return content;
  }
  // 去重 Name
  const cacedNames = [];

  for (let i = 0; i < stocks.length; i++) {
    const { stockName } = stocks[i];
    if (cacedNames.includes(stockName)) {
      continue;
    }

    cacedNames.push(stockName);
    content = content.replace(
      stockName,
      `<span class="link-stock" data-code="${stocks[i].stockCode}" data-market="${stocks[i].stockMarket}" >${stockName}</span>`
    );
  }
  return content;
}

export function removeWhiteSpaceInTags(html) {
  return html.replace(/>\s+|\s+</g, function (m) {
    return m.trim();
  });
}

export function removeTags(content = '') {
  return content.replace(
    /<a([\s\S]*?)href="([\s\S]*?)"([\s\S]*?)>([\s\S]*?)<\/a>/gi,
    ''
  );
}

// 处理详情页表格样式
export function removeTableStyle(content) {
  const r = /<table[^>]*?>(.*?)<\/table>/g;
  const str = content.replace(/(\r|\n|\u0085|\u2028|\u2029)/g, '').replace(r, tableStr => {
    // 增加一层div，支持左右滑动
    let resTableStr = `<div class="swipe-table" style="overflow: scroll;">${tableStr}</div>`;
    // 没有th标签时，第一行td转为th
    if (resTableStr.indexOf('</th>') === -1) {
      resTableStr = resTableStr.replace(/<tr.*?<\/tr>/, $0 => $0.replace(/td/g, 'th'));
    }
    return resTableStr;
  });
  return str;
}

export const { disclaimer } = disclaimerConfig;
